import { Typography } from "@material-ui/core";
import { Business } from "@mui/icons-material";

import { useGetVmsSearchRightsQuery } from "@/api/elasticSearch/vmsSearchApi";
import { ArchiveCabinetInfo } from "@/utilities/types/archive";
import { SearchIndex } from "@/utilities/types/search";

import { useStyles } from "./UnitInfoBoxStyles";


export const ArchiveCabinetInfoBox: React.FC<ArchiveCabinetInfo> = ({
    clientName,
    liveUnitName,
    locationName,
}) => {
    const classes = useStyles();
    const { data: searchRightsData } = useGetVmsSearchRightsQuery({
        indices: [SearchIndex.LiveUnits, SearchIndex.ArchiveCabinets, SearchIndex.Clients],
    });

    return (
        <>
            <Typography className={classes.title}>{locationName}</Typography>
            {liveUnitName &&
                <div className={classes.row}>
                    <Typography className={classes.infoText}>{liveUnitName}</Typography>
                </div>
            }
            {searchRightsData && searchRightsData.data.is_multi_client && clientName &&
                <div className={classes.row}>
                    <Business className={classes.icon} />
                    <Typography className={classes.infoText}>{clientName}</Typography>
                </div>
            }
        </>
    );
};
